import {Formik} from "formik";
import {Button, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React from "react";
import axios from "axios";
import {useParams} from "react-router-dom";

export function StudentListUploader(props) {
    let { caseid } = useParams();
    return(
        <Formik
            initialValues={{  csv: null}}
            validate={values => {
                const errors = {};
                if (!values.csv) {
                    errors.csv = 'Required';
                }
                return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
                const formData = new FormData();
                formData.append("students", values.csv);
                axios.post(  "/api/case/"+caseid+"/studentcsv", formData).then(res => {
                    if(res.data === ""){
                        alert("Something went wrong, please retry");
                    }
                    props.cb();
                    setSubmitting(false);
                }).catch(err => {
                    alert("Something went wrong, please retry");
                });
            }}
        >
            {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue
                  /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                    <Row className="mt-5">

                        <hr/>
                        <h5>
                            Upload CSV
                        </h5>
                        <span style={{color: "red"}}>{errors.csv && touched.csv && errors.csv}</span>
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>Upload student list CSV</Form.Label>
                            <Form.Control name="csv" type="file" onChange={(event) => {
                                setFieldValue("csv", event.currentTarget.files[0]);
                            }}/>
                        </Form.Group>
                        <Button type="submit" disabled={isSubmitting} variant="primary" >
                            Save CSV
                        </Button>
                    </Row>
                </form>
            )}
        </Formik>
    );
}